<script setup lang="ts">
import { Menu } from "@headlessui/vue";
</script>

<template>
  <Menu class="dropdown" as="div">
    <slot></slot>
  </Menu>
</template>

<style lang="scss" scoped>
.dropdown {
  position: relative;
}
</style>
